// import { th } from 'date-fns/locale';

import moment from 'moment';

const numberWithCommas = (x) => {
    var parts = x.toString().split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
};

const toFixed = (value, precision, thousandSep) => {
    if (value === undefined) return 0;
    if (value === null) return 0;
    if (value === ' - ') return value;

    try {
        value = value.toFixed(precision);

        var p = precision || 0,
            power = Math.pow(10, precision),
            absValue = Math.abs(Math.round(value * power)),
            result = (value < 0 ? '-' : '') + String(Math.floor(absValue / power));

        if (p > 0) {
            var fraction = String(absValue % power),
                padding = new Array(Math.max(p - fraction.length, 0) + 1).join('0');

            result += '.' + padding + fraction;
        }

        if (thousandSep === true) {
            return numberWithCommas(result);
        }

        return result;
    } catch (error) {
        return 0;
    }
};

const calcPercentage = (w1, w2) => {
    if (w1 === 0) return 0;
    const result = ((w2 - w1) / w1) * 100;

    return result;
};

const toFixed2 = (value, precision, thousandSep) => {
    const r = toFixed(value, precision, thousandSep).toString();
    const size = precision + 4;
    return padRight('0', r, size);
};

const padRight = (pad, str, size) => {
    if (typeof str === 'undefined') return pad;

    if (str.length >= size) return str.substring(0, size);

    while (str.length < size) str += pad;
    return str;

    // if (padRight) {
    //     return str + pad.slice(-pad.length);
    // } else {
    //     return pad + str.substring(0, pad.length);
    // }
};

const toEpoch = (str) => {
    var epoch = moment(str).unix();
    return epoch;
};

const eurSign = (p) => {
    return '€ ' + p;
};

const formatter = {
    toEpoch,
    eurSign,
    toFixed,
    toFixed2,
    padRight,

    calcPercentage,
};

export default formatter;
